import config from 'shared/config';
import connector from 'api/http';

import {
  unmarshalInsurers,
  unmarshalRefData,
} from 'scenes/common/api/referenceData';
import {
  ApiData,
  RecentInsurerOptions,
  RefDataType,
} from 'scenes/common/types';

const referenceDataApi = (baseUrl: string = config.baseUrls.BFF_BASE_URL) => {
  const server = connector(baseUrl);

  return {
    getInsurers: (): Promise<ApiData<RecentInsurerOptions>> =>
      server.get('/referencedata/home/HOMEINSUR').then(unmarshalInsurers),

    getBuildingTypes: (): Promise<ApiData<RefDataType[]>> =>
      server.get('/referencedata/home/BLD_TYPE').then(unmarshalRefData),

    getBuildYear: (): Promise<ApiData<RefDataType[]>> =>
      server.get('/referencedata/home/BLDNG_YR').then(unmarshalRefData),

    getRoofMaterial: (): Promise<ApiData<RefDataType[]>> =>
      server.get('/referencedata/home/ROOF_MTLR').then(unmarshalRefData),

    getWallMaterial: (): Promise<ApiData<RefDataType[]>> =>
      server.get('/referencedata/home/WALL_MTLR').then(unmarshalRefData),

    getHomeSecurity: (): Promise<ApiData<RefDataType[]>> =>
      server.get('/referencedata/home/HOMESCRITY').then(unmarshalRefData),

    getMortgageProviders: (): Promise<ApiData<RefDataType[]>> =>
      server.get('/referencedata/home/MRTGAGEPRV').then(unmarshalRefData),
  };
};

export default referenceDataApi;
